// API configuration - use relative URLs so nginx can proxy them
// This works because nginx proxies /signup, /auth, etc. to the goscript service
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

// Helper function to get the full API URL
export const getApiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  
  if (API_BASE_URL) {
    // If API_BASE_URL is set, use it
    return `${API_BASE_URL}/${cleanEndpoint}`;
  } else {
    // Otherwise use relative URL (will be proxied by nginx)
    return `/${cleanEndpoint}`;
  }
};

// FastAPI-routed endpoints (quiz questions, hashes, cache-status) are
// dispatched by nginx on path prefix just like goscript's, so this shares
// getApiUrl's logic rather than needing a separate base URL.
export const getFastApiUrl = getApiUrl;

